import React from "react";
import { usePortfolioConfig } from "../contexts/PortfolioConfigContext";
import "./PortfolioConfigModal.css";

const PortfolioConfigModal = ({ isOpen, onClose }) => {
  const { getAvailableDataSources, updateDataSource } = usePortfolioConfig();
  const dataSources = getAvailableDataSources();

  if (!isOpen) return null;

  const handleDataSourceChange = async (sourceId, enabled) => {
    await updateDataSource(sourceId, enabled);
  };

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="modal-content portfolio-config-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="portfolio-config-title"
      >
        <div className="modal-header">
          <div id="portfolio-config-title" style={{ fontWeight: 600 }}>
            Configuración de Fuentes de Datos
          </div>
          <button className="btn-secondary" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="modal-body">
          <div className="config-section">
            <h3>Fuentes de Datos del Portafolio</h3>
            <p className="config-description">
              Selecciona las fuentes de datos que deseas incluir en tu análisis
              de portafolio.
            </p>

            <div className="data-sources-list">
              {dataSources.map((source) => (
                <div
                  key={source.id}
                  className={`data-source-item ${
                    !source.available ? "disabled" : ""
                  }`}
                >
                  <div className="data-source-header">
                    <div className="data-source-info">
                      <h4>{source.name}</h4>
                      <p className="data-source-description">
                        {source.description}
                      </p>
                    </div>
                    <div className="data-source-controls">
                      <label className="checkbox-container">
                        <input
                          type="checkbox"
                          checked={source.enabled}
                          disabled={!source.available}
                          onChange={(e) =>
                            handleDataSourceChange(source.id, e.target.checked)
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>

                  {!source.available && (
                    <div className="unavailable-notice">
                      <span className="unavailable-icon">🚧</span>
                      <span>
                        Esta fuente de datos no está disponible actualmente
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="config-section">
            <h3>Información</h3>
            <div className="info-box">
              <p>
                <strong>Banco Bice:</strong> Actualmente disponible. Los datos
                se obtienen automáticamente mediante scraping de la plataforma
                web del banco.
              </p>
              <p>
                <strong>Sura:</strong> En desarrollo. Próximamente estará
                disponible para integración con los datos de portafolio de Sura.
              </p>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-primary" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default PortfolioConfigModal;
